export const roles = {
  SUPER_ADMIN: "Admin",
  USER_ROLE: "Usuario",
};
